export default __webpack_public_path__ + "static/media/auth-slide-1.7657e506.png";